import { useCallback, useState } from 'react'
import type { NotificationType} from 'src/store/sound';
import { useSoundActions } from 'src/store/sound'
import { useInitialUserInteraction } from './useInitialUserInteraction';

export const useSoundNotification = () => {
  const [hasUserInteracted, setHasUserInteracted] = useState(false)
  
  const soundStoreActions = useSoundActions()

  // Play notification on initial interaction
  useInitialUserInteraction(() => {
    setHasUserInteracted(true)
  })

  const playNotification = useCallback(
    (soundId: string) => {
      hasUserInteracted && soundStoreActions.playNotification(soundId as NotificationType)
    },
    [hasUserInteracted, soundStoreActions]
  )

  return {
    playNotification
  }
}
